import { render, staticRenderFns } from "./TableCustom.vue?vue&type=template&id=64617be6&scoped=true&"
import script from "./TableCustom.vue?vue&type=script&lang=js&"
export * from "./TableCustom.vue?vue&type=script&lang=js&"
import style0 from "./TableCustom.vue?vue&type=style&index=0&id=64617be6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64617be6",
  null
  
)

export default component.exports